import React, {useEffect, useState} from 'react';
import {Form, Grid, Header, Message, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {CreateMotoristaRequest} from "../../../../models/requests/create-motorista-request";
import useDriverService from "../../../../services/backoffice/hooks/useDriverService";
import useFleetService from "../../../../services/backoffice/hooks/useFleetService";
import {ShortDto} from "../../../../models/short-dto";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import {SessionUser} from "../../../../models/session-user";
import SessionStorage from "../../../../store/session";
import {useBlockUI} from "../../../../shared/services/block-ui-service";
import useVehiclePlateService from "../../../../services/backoffice/hooks/useVehiclePlateService";

const CreateMotoristaPage = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [motorista, setMotorista] = useState<Partial<CreateMotoristaRequest>>({});
    const navigate = useNavigate();
    const [fleets, setFleets] = useState<ShortDto[]>([]);
    const [clients, setClients] = useState<ShortDto[]>([]);
    const [drivers, setDrivers] = useState<ShortDto[]>([]);
    const [selectedClient, setSelectedClient] = useState<string | undefined>('');
    const {createMotorista, getAllFilteredRastreadorLogsDriversName} = useDriverService();
    const {getAllFleetsShortDto} = useFleetService();
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const blockUI = useBlockUI();
    const [vehiclePlates, setVehiclePlates] = useState<ShortDto[]>([])
    const {getAllClientsShortDto} = useClientService();
    const {getAllVehiclePlatesShortDtoFiltered} = useVehiclePlateService();

    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }
        updateSessionUser()
    }, [])

    useEffect(() => {
        function ListVehicleplates() {
            getAllVehiclePlatesShortDtoFiltered().then((response) => {
                setVehiclePlates(response);
            })
                .catch(error => {

                })
        }

        ListVehicleplates()
    }, [])

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setMotorista((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));
    };

    useEffect(() => {
        function listClients() {
            setLoading(true)
            getAllClientsShortDto().then((response) => {
                setClients(response);
            }).finally(() => {
                setLoading(false)
            })
        }

        listClients()
    }, [])

    useEffect(() => {
        function listDriversNamesAndFleets() {
            if (selectedClient) {
                setLoading(true)
                const filter = {clientId: selectedClient};
                getAllFleetsShortDto(filter).then((response) => {
                    setFleets(response)
                    getAllFilteredRastreadorLogsDriversName(filter).then((response) => setDrivers(response))
                        .finally(() => setLoading(false))
                })
            }
        }
        listDriversNamesAndFleets()
    }, [selectedClient]);


    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        setLoading(true)
        try {
            const resp = (await createMotorista({
                ...motorista,
            }));
            const drivers = resp.data;
            if (resp.success) {
                drivers.forEach((result) => {
                    toast.success(
                        <div>
                            {result.message}
                            {result.password ? (
                                <button onClick={() => handleCopyPassword(result.password)}>Copiar senha</button>
                            )
                            : 'Use a mesma senha para login ou altere a senha desse usuário'}
                        </div>,
                        {autoClose: false}
                    );
                });

                navigate('/backoffice/motoristas/');
            } else {
                drivers.forEach((result) => {
                    if (!result.success) {
                        toast.error(result.message);
                    }
                });
            }
        } catch (error) {
            console.error('Erro ao criar motorista:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleCopyPassword = (password: string) => {
        navigator.clipboard.writeText(password);
        toast.info('Senha copiada para a área de transferência');
    };


    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Motoristas / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>

                        <Form.Select
                            label={'Qual o Cliente do Motorista?'}
                            options={clients}
                            placeholder='Selecione uma opção'
                            value={motorista?.clienteId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setSelectedClient(selectedValue);
                                setMotorista(prevMotorista => ({...prevMotorista, clienteId: selectedValue}));
                            }}
                        />

                        <Form.Select
                            loading={loading}
                            label="Quais motoristas a serem adicionados ao cliente?"
                            name="driversIds"
                            placeholder="Selecione os motoristas desejados"
                            options={drivers.map(driver => ({key: driver.text, text: driver.text, value: driver.text}))}
                            value={motorista?.driversNames}
                            multiple
                            search
                            clearable
                            onChange={(evento: any, data: any) => {
                                const selectedDrivers = data.value;
                                setMotorista(prevMotorista => ({
                                    ...prevMotorista,
                                    driversNames: selectedDrivers,
                                }));
                            }}
                            disabled={!motorista?.clienteId}
                        />

                        {sessionUser?.userData?.profile == 'Admin'
                            &&
                            <Form.Select
                                label={'Qual a operação do motorista?'}
                                options={fleets}
                                placeholder='Selecione uma opção'
                                value={motorista?.fleetId || ''}
                                search
                                clearable
                                onChange={(e: any, data: any) => {
                                    const selectedValue = data.value;
                                    setMotorista(prevMotorista => ({...prevMotorista, fleetId: selectedValue}));
                                }}
                                disabled={!motorista?.clienteId}
                            />
                        }

                        <Message info size="small">
                            <Message.Header>Premiações diárias</Message.Header>
                            <p>
                                Para que as premiações diárias sejam calculadas, o motorista precisa estar
                                vinculado a uma <strong>frota (operação)</strong>.
                                {sessionUser?.userData?.profile === 'Admin'
                                    ? ' Selecione acima ou vincule depois em Operações → Ver motoristas da frota.'
                                    : ' Após criar, vincule em Operações → Ver motoristas da frota.'}
                            </p>
                        </Message>

                        <Form.Select
                            label={'Placa do motorista (opcional)'}
                            options={vehiclePlates}
                            placeholder='Selecione uma opção'
                            value={motorista?.vehiclePlateId || ''}
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setMotorista(prevPlate => ({...prevPlate, vehiclePlateId: selectedValue}));
                            }}
                        />


                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/motoristas/')} grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateMotoristaPage;
